import { Localization } from 'digicon-web-localization/localization';
import { initLocalStorage } from 'digicon-web-local-storage/localStorage';

export class LocalizationManager {
    constructor(modules, managers) {
        this.modules = modules;
        this.managers = managers;

        this.managers.localizationManager = this;
    }

    async init() {
		initLocalStorage('lcoe_');
        this.modules.localization = new Localization({
			container: 'localizationContainer',
			languages: [{
				code: 'en-EN',
				txt: 'en'
			}],
			uiType: 'none'
		});

        if (this.modules.localization.getLocale() == null) {
			//init to spanish
			this.modules.localization.setLocale('en-EN');
		}

		//onLocalized
		await new Promise((resolve, reject) => {
			this.modules.localization.subscribe('onInitialized', () => {
				resolve();
			});

			this.modules.localization.init();
		});
    }
}